// extracted by mini-css-extract-plugin
export var desktopLogo = "Header-module--desktopLogo--2af7b";
export var desktopNav = "Header-module--desktopNav--a2596";
export var linksContainer = "Header-module--linksContainer--8a039";
export var logoWrapper = "Header-module--logoWrapper--a9f79";
export var mobileLogo = "Header-module--mobileLogo--5201f";
export var mobileNav = "Header-module--mobileNav--65c45";
export var navBar = "Header-module--navBar--ee3b6";
export var navWrapper = "Header-module--navWrapper--c302b";
export var skipLink = "Header-module--skipLink--9caac";